export default ({ data, settings }) => {
    // 金額表格
    let paymentBody = [];
    if (data.cny === 'TWD') {
    // 台幣
        paymentBody = [
            [
                {
                    text: '應付金額',
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 8, 0, 5],
                    fontSize: 8,
                    bold: true,
                },
                {
                    text: data.amt,
                    alignment: 'right',
                    fontSize: 13,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 5, 0, 5],
                },
                {
                    text: data.cny,
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 11, 0, 5],
                },
            ],
            [
                {
                    text:
            data.taxAmt === 0
                ? '- 代扣所得稅'
                : `- 代扣所得稅 ${data.taxRatio}%`,
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.taxAmt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text:
            data.gen2Amt === 0
                ? '- 代扣二代健保'
                : `- 代扣二代健保 ${data.gen2Ratio}%`,
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.gen2Amt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text: '= 實付金額',
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.realPayAmt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
        ];
    } else {
    // 外幣
        paymentBody = [
            [
                {
                    text: '應付金額',
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 8, 0, 5],
                    fontSize: 8,
                    bold: true,
                },
                {
                    text: data.amt,
                    alignment: 'right',
                    fontSize: 13,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 5, 0, 5],
                },
                {
                    text: data.cny,
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 11, 0, 5],
                },
            ],
            [
                {
                    text: `應付金額 (約當台幣)\n 約定匯率：${data.cnyRat}`,
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.amtTw,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text:
            data.taxAmt === 0
                ? '－ 代扣所得稅 (台幣)'
                : `－ 代扣所得稅 ${data.taxRatio} (台幣)`,
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.taxAmt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text:
            data.gen2Amt === 0
                ? '－ 代扣二代健保 (台幣)'
                : `－ 代扣二代健保 ${data.gen2Ratio}% (台幣)`,
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.gen2Amt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text: '＝ 實付金額 (原幣別)',
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.realPayAmtInOrignalCny,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.cny,
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
            [
                {
                    text: '＝ 實付金額 (約當台幣)',
                    fillColor: '#eeeeee',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: data.realPayAmt,
                    alignment: 'right',
                    fontSize: 8,
                    bold: true,
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
                {
                    text: 'TWD',
                    alignment: 'right',
                    border: [false, false, false, true],
                    borderColor: ['', '', '', '#cccccc'],
                    margin: [0, 3, 0, 3],
                },
            ],
        ];
    }

    function getPageHeader(pageNum, pageBreakAtFirst = false) {
        return {
            margin: [0, 0, 0, 0],
            layout: 'noBorders',
            table: {
                widths: ['*', 180],
                body: [
                    [
                        [
                            {
                                text: data.cmpName,
                                style: { fontSize: 14, bold: true },
                            },
                            {
                                text: data.title,
                                style: { fontSize: 23, bold: true, margin: [0, 5, 0, 0] },
                            },
                        ],
                        {
                            margin: [0, 0, 0, 0],
                            layout: 'noBorders',
                            table: {
                                widths: [80, 'auto'],
                                body: [
                                    ['系統單號', data.systemNo],
                                    ['公司經辦人', data.creator],
                                    ['申請日期', data.createDat],
                                    ['印表日期', data.currDat],
                                ],
                            },
                        },
                    ],
                ],
            },
            pageBreak: pageBreakAtFirst ? 'before' : null,
        };
    }

    const def = {
        pageSize: settings.pageSize || 'A4',
        pageOrientation: settings.pageOrientation || 'portrait',
        defaultStyle: {
            font: 'NotoSansTC',
            fontSize: 8,
        },
        styles: {
            docTitle: {
                fontSize: 22,
                bold: true,
            },
        },
        content: [
            getPageHeader(1),
            {
                margin: [0, 15, 0, 0],
                layout: {
                    hLineWidth() {
                        return 1;
                    },
                    paddingLeft() {
                        return 0;
                    },
                    paddingRight() {
                        return 0;
                    },
                    paddingTop: (i) => (i === 0 ? 2 : 0),
                    paddingBottom: (i) => (i === 0 ? 2 : 0),
                },
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            {
                                text: '勞務內容',
                                border: [false, true, false, true],
                                fontSize: 9,
                                bold: true,
                                margin: [0, 1.5, 0, 1.5],
                            },
                            {
                                text: '領款人',
                                border: [false, true, false, true],
                                fontSize: 9,
                                bold: true,
                                margin: [0, 1.5, 0, 1.5],
                            },
                        ],
                        [
                            {
                                border: [false, false, false, false],
                                table: {
                                    widths: [60, '*'],
                                    body: [
                                        [
                                            {
                                                text: '所屬專案',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.projectNam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '勞務摘要',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.nam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '勞務內容',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.description,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                    ],
                                },
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    widths: [60, '*'],
                                    body: [
                                        [
                                            {
                                                text: '姓名',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.payee,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '國籍',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.nationalityNam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: data.idTypTxt,
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.bsn,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '戶籍地址',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.permanentAddrTxt,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '聯絡地址',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.contactAddrTxt,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '聯絡電話',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.phone,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: 'E-mail',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.email,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                    ],
                                },
                            },
                        ],
                    ],
                },
            },
            {
                margin: [0, 15, 0, 0],
                layout: {
                    hLineWidth() {
                        return 1;
                    },
                    paddingLeft() {
                        return 0;
                    },
                    paddingRight() {
                        return 0;
                    },
                    paddingTop: (i) => (i === 0 ? 2 : 0),
                    paddingBottom: (i) => (i === 0 ? 2 : 0),
                },
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            {
                                text: '領款金額',
                                colSpan: 2,
                                border: [false, true, false, true],
                                fontSize: 9,
                                bold: true,
                                margin: [0, 1.5, 0, 1.5],
                            },
                            {},
                        ],
                        [
                            {
                                border: [false, false, false, false],
                                table: {
                                    widths: [60, '*'],
                                    body: [
                                        [
                                            {
                                                text: '所得類別',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.incomeTypeNam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '業別代號',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.serviceTypeNam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '預計支領方式',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.plannedPayWayTxt,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '預計支領日',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.plannedPayDatTxt,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        // [
                                        //     {
                                        //         text: '實際付款方式',
                                        //         fillColor: '#eeeeee',
                                        //         border: [false, false, false, true],
                                        //         borderColor: ['', '', '', '#cccccc'],
                                        //     },
                                        //     {
                                        //         text: data.realPayWayTxt,
                                        //         border: [false, false, false, true],
                                        //         borderColor: ['', '', '', '#cccccc'],
                                        //     },
                                        // ],
                                        // [
                                        //     {
                                        //         text: '實際付款日',
                                        //         fillColor: '#eeeeee',
                                        //         border: [false, false, false, true],
                                        //         borderColor: ['', '', '', '#cccccc'],
                                        //     },
                                        //     {
                                        //         text: data.realPayWayTxt,
                                        //         border: [false, false, false, true],
                                        //         borderColor: ['', '', '', '#cccccc'],
                                        //     },
                                        // ],
                                        [
                                            {
                                                text:
                          data.accountType === 2
                              ? '收款銀行\n（外國）'
                              : '收款銀行',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.bankNameAll,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '收款戶名',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.bnkNam,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                        [
                                            {
                                                text: '收款帳號',
                                                fillColor: '#eeeeee',
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                            {
                                                text: data.bnkAcc,
                                                border: [false, false, false, true],
                                                borderColor: ['', '', '', '#cccccc'],
                                            },
                                        ],
                                    ],
                                },
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    widths: [110, '*', 18],
                                    body: paymentBody,
                                },
                            },
                        ],
                    ],
                },
            },
        ],
    };

    if (settings.drawSignArea) {
        def.content.push({
            margin: [0, 15, 0, 0],
            layout: {
                paddingLeft() {
                    return 6;
                },
                paddingRight() {
                    return 6;
                },
                paddingTop() {
                    return 6;
                },
                paddingBottom() {
                    return 6;
                },
            },
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: '\n\n\n領款人： __________________________________（簽名或蓋章） __________________年__________月__________日',
                            alignment: 'center',
                        },
                    ],
                ],
            },
        });
    }

    // 身分證正反
    if (settings.drawIdImage) {
    // 空白（預設）
        const idAreaBody = [
            { text: '\n\n\n\n\n(正面)\n\n\n\n\n\n\n', alignment: 'center' },
            { text: '\n\n\n\n\n(反面)\n\n\n\n\n\n\n', alignment: 'center' },
        ];

        // 有設定要印身分證正反
        if (settings.drawIdImage) {
            // 正面
            if (data.idCardFrontBase64) {
                idAreaBody[0] = {
                    image: data.idCardFrontBase64,
                    fit: [245, 165],
                    alignment: 'center',
                };
            }
            // 背面
            if (data.idCardBackBase64) {
                idAreaBody[1] = {
                    image: data.idCardBackBase64,
                    fit: [245, 165],
                    alignment: 'center',
                };
            }
        }
        def.content.push({
            margin: [0, 15, 0, 0],
            table: {
                widths: ['*', '*'],
                body: [
                    [
                        {
                            text: '身分證（居留證/護照）影本黏貼處',
                            colSpan: 2,
                            alignment: 'center',
                        },
                        {},
                    ],
                    idAreaBody,
                ],
            },
        });
        def.content.push({
            text: '（僅供本次領款資料核對及所得扣繳申報使用。）',
            margin: [0, 5, 0, 0],
        });
    }

    // 第二頁：存摺影本、工會投保證明
    if (settings.drawPassbookImage || settings.drawUnionInsuranceImage) {
    // 頁首
        def.content.push(getPageHeader(2, true));

        // 有設定要印存摺影本
        if (settings.drawPassbookImage) {
            // 空白（預設）
            const passbookAreaBody = [
                {
                    text: '\n\n\n\n\n\n\n\n(封面)\n\n\n\n\n\n\n\n\n\n\n\n',
                    alignment: 'center',
                },
            ];
            def.content.push({
                margin: [0, 15, 0, 0],
                table: {
                    widths: ['*'],
                    body: [[{ text: '存摺封面', alignment: 'center' }], passbookAreaBody],
                },
            });
            // 有檔案
            if (data.passbookDocBase64) {
                passbookAreaBody[0] = {
                    image: data.passbookDocBase64,
                    fit: [400, 250],
                    alignment: 'center',
                };
            }
        }

        // 有設定要印工會投保證明
        if (settings.drawUnionInsuranceImage) {
            // 空白（預設）
            const unionInsuranceAreaBody = [
                {
                    text:
            '\n\n\n\n\n\n\n\n\n\n\n\n\n(證明文件)\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                    alignment: 'center',
                },
            ];
            def.content.push({
                margin: [0, 15, 0, 0],
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: '職業工會投保證明', alignment: 'center' }],
                        unionInsuranceAreaBody,
                    ],
                },
            });
            // 有檔案
            if (data.unionInsuranceDocBase64) {
                unionInsuranceAreaBody[0] = {
                    image: data.unionInsuranceDocBase64,
                    fit: [500, 365],
                    alignment: 'center',
                };
            }
        }
    }

    return def;
};
